export const stripStateBlocks = (message: string): string => {
    const withoutState = message.replace(/\[STATE][\s\S]*?\[\/STATE]/g, '')

    return withoutState.replace(/\n{3,}/g, '\n\n').trim()
}
